import { Injectable } from '@angular/core';
//import { Subject } from './../../../../node_modules/rxjs/internal/Subject';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseTabsService {

  constructor() { }

  private activeTabSubject = new Subject<string>();

  ActiveTab = this.activeTabSubject.asObservable();

  SetActiveTab(id: string){
    this.activeTabSubject.next(id);
  }
}
